import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  RouterStateSnapshot,
} from '@angular/router';
import { NavigationService } from '../../navigation/navigation.service';
import { HOME_MASTER_ROUTE } from '../main.data';
import { IDeepLinkProperties } from '../../navigation/deep-link-properties.interface';
import { NavigationBuilder } from '../../navigation/navigation.builder';

@Injectable()
export class RedirectGuard implements CanActivate {
  constructor(
    private _navigationService: NavigationService,
    private _navigationBuilder: NavigationBuilder
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    try {
      const deepLinkParam = route.queryParamMap.get('deepLink');

      // Prevent users from abusing internal deep links using /redirect route
      const deepLinkProperties: IDeepLinkProperties = this._navigationBuilder.buildDeepLinkProperties(
        decodeURIComponent(deepLinkParam)
      );
      if (deepLinkProperties.internal) {
        this._navigationService.goTo(HOME_MASTER_ROUTE);
      } else {
        this._navigationService.goToDeepLink(decodeURIComponent(deepLinkParam));
      }
    } catch (e) {
      this._navigationService.goToByUrl('/');
    }

    return false;
  }
}
